module.exports = {"finance-blocks":{"currency":"({{currency}}) ","lastUpdated":"Updated {{lastUpdateTime}}. ","quotesDelayed":"Quotes delayed at least 15min. ","poweredBy":"Financial content solutions powered by ","poweredByProvider":"CloudQuote.io ","placeholder":"Search Symbol or Company Name","disclaimer":"Disclaimer ","field-headers":{"price":"Price","symbol":"Symbol","name":"Index","changePrice":"Change","changePercent":"Change %"}}}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-blocks/src/intl.json
// module id = 788
// module chunks = 0